module.exports = __webpack_public_path__ + "static/media/Dashboard_Homepage_Image.993eeee7.png";